import $ from 'jquery';

// set position absolute above top screen (hidden), set position fixed once all element visible
const onScrollUp = ($nav, $stickyNav, currentTop) => {
    const classPlaced = 'placed';
    const classFixed = 'fixed';
    const mainNavH = $('.js-flex-fixed').outerHeight() || 0;

    // set positon absolute if scroll up and top != 0 + main nav
    if ($nav.hasClass(classFixed) && !$nav.hasClass(classPlaced)) {
        $nav.addClass(classPlaced);
        $stickyNav.css('top', currentTop);
    }

    // set position fixed if main nav have top 0, simply detect `.js-flex-fixed.placed` length <= 0
    if ($nav.hasClass(classPlaced)) {
        if ($('.js-flex-fixed.placed').length <= 0) {
            $nav.removeClass(classPlaced);
            $stickyNav.css('top', mainNavH);
        }
    }

    // remove fixed if window scroll above sticky nav
    if ($nav.offset().top > currentTop + mainNavH) {
        $nav.removeClass(classFixed);
    }
};

// set position absolute on current fixed position
const onScrollDown = ($nav, $stickyNav, currentTop) => {
    const classPlaced = 'placed';
    const classFixed = 'fixed';
    const mainNavH = $('.js-flex-fixed').outerHeight() || 0;

    // set positon absolute if scroll down and main nav != 0, simply detect `.js-flex-fixed.placed` length > 0
    if ($nav.hasClass(classFixed) && !$nav.hasClass(classPlaced)) {
        if ($('.js-flex-fixed.placed').length > 0) {
            $nav.addClass(classPlaced);
            $stickyNav.css('top', currentTop + mainNavH);
        }
    }

    // set positon fixed if scroll down and main nav < 0, simply detect `.js-flex-fixed.placed` length <= 0
    if ($nav.hasClass(classPlaced)) {
        if ($('.js-flex-fixed.placed').length <= 0) {
            $nav.removeClass(classPlaced);
            $stickyNav.css('top', 0);
        }
    }

    // set class fixed if position above viewport
    if ($nav.offset().top <= currentTop) {
        // reset top if not, happen on scroll up and main nav far with sticky nav
        if (!$nav.hasClass(classFixed)) {
            $stickyNav.css('top', 0);
        }

        $nav.addClass(classFixed);
    }
};

// check if slider item in viewport
const setVisible = index => {
    const $items = $('.js-sticky-nav .slide-item');
    const viewport = $('.js-sticky-nav .inner').innerWidth();
    let width = 0;

    // on mobile, active slider item
    if ($(window).width() <= 768) {
        $('.js-sticky-nav .inner').slick('slickGoTo', index);
        return;
    }

    // on tablet up, slide it manually
    for (let i = 0; i <= index; i += 1) {
        width += Math.ceil($($items[i]).outerWidth(i !== index));
    }

    if (width >= viewport) {
        $('.js-sticky-nav .slick-track').css({ transform: `translate3d(-${width - viewport}px, 0, 0)` });
    } else {
        $('.js-sticky-nav .slick-track').css({ transform: 'translate3d(0, 0, 0)' });
    }
};

const initStickyNav = () => {
    const offextTopFixed = 24;
    const offsetBottomFixed = 24;
    const classPlaced = 'placed';
    const classFixed = 'fixed';
    const iOS = $('html.ios').length > 0;

    const $nav = $('.js-sticky-nav');
    const $items = $('.js-scroll-spy');
    const $stickyNav = $('.js-sticky-nav .js-fixed-container');
    let lastScrollTop = 0;

    if ($nav.length <= 0) return;

    $(window).bind('scroll', () => {
        const currentTop = $(window).scrollTop();
        let offsetTop = 0;
        let isPlaced = $nav.hasClass(classPlaced);
        isPlaced = iOS ? false : isPlaced;

        // get top offset base on responsive css
        if ($stickyNav.css('position') === classFixed) {
            offsetTop = $stickyNav.outerHeight(false) + parseInt($stickyNav.css('top'), 10) + offextTopFixed;
        }

        // bind target item and apply spy
        $items.each(function () {
            const $itemTop = $(this).offset().top - offsetTop;
            const $itemBottom = $itemTop + ($(this).height() - offsetBottomFixed);

            if (currentTop >= $itemTop && currentTop <= $itemBottom && !isPlaced) {
                const id = $(this).attr('id');
                const $navElem = $(`a[href="#${id}"]`);
                $navElem.addClass('show-as-active').siblings().removeClass('show-as-active');

                // make sure current active is visible
                setVisible($navElem.data('slick-index'));
            }
        });

        if (currentTop > lastScrollTop) {
            onScrollDown($nav, $stickyNav, currentTop);
        } else {
            onScrollUp($nav, $stickyNav, currentTop);
        }
        lastScrollTop = currentTop;
    });

    // trigger it once
    $(window).trigger('scroll');

    // animate scroll on click item
    $nav.find('.slide-item').click(function (e) {
        e.preventDefault();

        const $el = $(this);
        const target = $el.attr('href');
        const navTop = $nav.hasClass(classPlaced) ? 0 : parseInt($stickyNav.css('top'), 10);
        const offsetTop = $stickyNav.outerHeight(false) + navTop + offextTopFixed;
        const mainNavH = $('.js-flex-fixed').outerHeight() || 0;
        const currentTop = $(window).scrollTop();
        let scrollTo = $(target).offset().top - (offsetTop - 1);

        // if scrollTo > currentTop && navTop > 0 => scrollTo += navTop
        // else if scrollTo < currentTop && navTop === 0 => scrollTo -= mainNavH
        if (scrollTo > currentTop && navTop > 0) {
            scrollTo += navTop;
        } else if (scrollTo < currentTop && navTop === 0) {
            scrollTo -= mainNavH;
        }

        // animate scroll and set the top -1px to trigger scroll spy
        $('html, body').animate({ scrollTop: scrollTo });
    });
};

$(() => {
    initStickyNav();
});



// WEBPACK FOOTER //
// ./src/sections/sticky-nav/s-sticky-nav.js